import { useState, useEffect } from 'react';

import { useGET } from 'hooks/useRequest';
import V2SimilarStock from './v2_similar_stock';
import SimilarStock from './similar_stock';

/**
 * Renders a <SimilarStock/> component
 * @param {Object} props
 * @param {String} props.productId - Current parent product.step_id
 * @param {Bool} props.isProductDetail - switch for page check
 * @param {String} props.currentStoreName - current location selected Name
 * @param {Number} props.currentStoreLocationId - current location selected ID
 * @param {String} props.tick - image passed in from pipeline
 * @param {String} props.similarStockUrl - url to get similar stock
 * @param {Bool} props.vatExclusive - switch case for showing inc/ex vat price
 * @param {Bool} props.v2Product - Bool check for V2 product detail page
 */

const SimilarStockContainer = ({
  productId,
  currentStoreName,
  currentStoreLocationId,
  quantity,
  tick,
  similarStockUrl,
  vatExclusive,
  v2Product,
  isProductDetail,
}) => {
  const [loading, setLoading] = useState(true);
  const [loadingPrices, setLoadingPrices] = useState(true);
  const [prices, setPrices] = useState([]);
  const [hideSimilarStock, setHideSimilarStock] = useState(true);
  const [similarStockItems, setSimilarStockItems] = useState([]);
  const { data: stockResponse } = useGET(
    `/store_stock/v1/request?products=${productId}&locations=${currentStoreLocationId}` ||
      null,
  );

  const { data: response, error } = useGET(
    `${similarStockUrl}?product_id=${productId}&location_id=${currentStoreLocationId}`,
  );

  // TODO: add in productsForPricing util function once it is in master!
  const productsForPricing = similarStockItems.length
    ? [...new Set(similarStockItems.map(p => p?.id))]
    : null;

  const { data: similarStockPrices } = useGET(
    similarStockItems.length
      ? `/product_price?products=${productsForPricing}`
      : null,
  );

  useEffect(() => {
    if (stockResponse) {
      if (+stockResponse[0].products[0]?.stock === 0) {
        setLoading(false);
      }
    }
  }, [stockResponse]);

  useEffect(() => {
    if (error) {
      setSimilarStockItems([]);
    }

    if (response) {
      setSimilarStockItems(response.filter(p => p !== null));
    }
  }, [error, response]);

  useEffect(() => {
    setLoadingPrices(true);
    if (similarStockPrices) {
      setPrices(similarStockPrices);
      setLoadingPrices(false);
    }
  }, [similarStockPrices]);

  if (loading) {
    return false;
  }

  if (!similarStockItems.length) {
    return false;
  }

  const StockProduct = v2Product ? V2SimilarStock : SimilarStock;

  return (
    <StockProduct
      productId={productId}
      similarStockItems={similarStockItems}
      setHideSimilarStock={setHideSimilarStock}
      hideSimilarStock={hideSimilarStock}
      isProductDetail={isProductDetail}
      currentStoreName={currentStoreName}
      currentStoreLocationId={currentStoreLocationId}
      tick={tick}
      vatExclusive={vatExclusive}
      loadingPrices={loadingPrices}
      prices={prices}
      quantity={quantity}
    />
  );
};

export default SimilarStockContainer;
